import React from 'react'
import ReservationTime from './components/ReservationTime';
import { Flex } from "@chakra-ui/react";

function Reservation() {
  return (
    <Flex direction="column" pt={{ base: "120px", md: "85px" }}>
    <ReservationTime />
    </Flex>
  )
}

export default Reservation